export enum BookingStatusEnum {
  PENDING = 1,
  CONFIRMED = 2,
  CANCELLED = 3,
}

/**
 * Keep in sync with `BookingStatusEnum` and values in `bookingstatus` table in the Database.
 */
export enum BookingStatusNameValueEnum {
  ALL = "All",
  CONFIRMED = "Confirmed",
  PENDING = "Pending",
  CANCELLED = "Cancelled",
}
